// Minimal typing over window.Telegram.WebApp, scoped to what Phase 1 uses.
// The SDK script is loaded via <script> in index.html, not npm, per
// Telegram's own recommendation for Mini Apps.

interface TelegramWebApp {
  initData: string;
  ready: () => void;
  expand: () => void;
  colorScheme: "light" | "dark";
  themeParams: Record<string, string>;
  MainButton: {
    setText: (text: string) => void;
    show: () => void;
    hide: () => void;
    onClick: (cb: () => void) => void;
    offClick: (cb: () => void) => void;
  };
  showAlert?: (message: string) => void;
  openLink?: (url: string) => void;
}

declare global {
  interface Window {
    Telegram?: { WebApp: TelegramWebApp };
  }
}

export function getTelegramWebApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function getInitData(): string {
  return getTelegramWebApp()?.initData ?? "";
}

// Opens an external URL via Telegram's own in-app browser when running
// inside a Mini App (so users never get navigated away from the Bot);
// falls back to a normal same-tab navigation outside Telegram (e.g. when
// testing this page directly in a desktop browser).
export function openExternalLink(url: string): void {
  const webApp = getTelegramWebApp();
  if (webApp?.openLink) webApp.openLink(url);
  else window.location.href = url;
}
